// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $timeout,
    Alert,
    CompanyUser,
    CorporateSettingsService,
    UserAccounts,
) {
    $scope.unblockCompanyUser = unblockCompanyUser;

    function unblockCompanyUser(userAccount) {
        updateUser('unblock', 'groups_users.user_unblocked_success', userAccount.companyUser);
    }

    function updateUser(updateType, key, companyUser) {
        CompanyUser.updateCompanyUser({
            companyId: companyId,
            id: companyUser.id,
            updateAction: updateType
        }, companyUser, function () {
            CompanyUser.identifyCompanyUser({
                companyId: companyId,
                uid: companyUser.saaspassUser.saaspassId
            }, function (data) {                
                $scope.companyUser = data;
                $scope.isBlocked = $scope.companyUser.blocked != 'NONE';
//                $scope.onGroupClick($scope.selectedGroup);
                $state.reload($state.current);
                $timeout(1000).then(() => Alert('success', key)  );
            });
        }, function (response) {
                Alert('danger', response.data.message);
        });
    }

    $scope.showBlockedAccounts = function (data) {
        $scope.userAccounts = data;
        $scope.showingBlockedAccounts = true;
    };

    let accountsResource = UserAccounts.getBlockedUsers({
        companyId: $state.params.companyId
    });
    accountsResource.$promise.then(function (data) {
        $scope.blockedAccounts = data;
        let blockedAccountss = [];
        for (let i = 0; i < data.length; i++){
            data[i]['companyUser']['saaspassUser']['saaspassId'];
            blockedAccountss.push(data[i]['companyUser']['saaspassUser']['saaspassId']);
        }
        var count = blockedAccountss.reduce(function(values, v) {
            if (!values.set[v]) {
                values.set[v] = 1;
                values.count++;
            }
            return values;
        }, { set: {}, count: 0 }).count;
        $scope.blockedAccountCount = count;
    });

    const companyId = $scope.companyId = $state.params.companyId;

    CorporateSettingsService.get(companyId).then(function (data) {
        $scope.settings = data;
        $scope.newSettings = angular.copy($scope.settings);
    });

    $scope.editRecoverySettings = editRecoverySettings;

    $scope.onGroupClick = function(group) {
        $scope.selectedFilter = 'ALL';
        $scope.displaySpinner = true;
        $scope.groupTable = true;
        $scope.activeDirectoryPage = false;
        $scope.pendingActiveDirectoryPage = false;
        $scope.showingBlockedAccounts = false;
        loadUserAccountsForGroup(group);
    }
    var loadUserAccountsForGroup = function(group) {
        UserAccounts.getAccountsForGroup({
            companyId : companyId,
            groupId : group.id
        }, function(data) {
            userAccounts = $scope.userAccounts = data;
            $scope.displaySpinner = false;
        });
        $scope.selectedGroup = group;
    };

    function editRecoverySettings() {
        CorporateSettingsService.save(companyId,$scope.newSettings)
            .then(() => {
                $scope.settings = $scope.newSettings;
                Alert('success', 'corporate.message.updated');
            }
        );
    }


}


// WEBPACK FOOTER //
// ./src/portal/states/company/recovery-center/recovery.controller.js